import React, { useCallback } from 'react'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineUploadIcon from 'components/Luxkit/Icons/line/LineUploadIcon'
import IconButton from 'components/Luxkit/Button/IconButton'

interface Props
  extends Omit<React.ComponentProps<typeof TextButton>, 'kind' | 'children'> {
  iconOnly?: boolean;
}

function ExportMediaContentButton(props: Props) {
  const { onClick, iconOnly } = props

  const onShareClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      onClick?.(e)
    },
    [onClick],
  )

  if (iconOnly) {
    return (
      <IconButton
        {...props}
        size="medium"
        shape="circle"
        kind="secondary"
        variant="dark"
        onClick={onShareClick}
      >
        <LineUploadIcon aria-hidden="true" />
      </IconButton>
    )
  }

  return (
    <TextButton
      kind="secondary"
      {...props}
      startIcon={<LineUploadIcon aria-hidden="true" />}
      onClick={onShareClick}
    >
      Create Marketing Promo
    </TextButton>
  )
}

export default ExportMediaContentButton
